/**
 * The detail column's whole visual vocabulary, in one place. The canvas is the
 * picture; this column is deliberately QUIET — a small mono heading, mono data
 * rows, and chips — so it never competes with the graph next to it. Every value
 * is an existing app token (surfaces, borders, the indigo accent); nothing here
 * is a new colour or a new shape.
 */

/** Section heading: small, mono, wide tracking, muted. */
export const detailHeading =
  'font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--app-text-muted)]';

/** One line of data under a heading. */
export const detailRow = 'font-mono text-[11px] leading-relaxed text-[var(--app-text)]';

/** A quieter line — captions, empty states, "inherits …". */
export const detailMuted = 'font-mono text-[10px] leading-relaxed text-[var(--app-text-muted)]';

/** A chip: one fact, boxed. */
export const detailChip =
  'inline-flex max-w-full items-center gap-1 border border-[var(--border-subtle)] bg-[var(--surface-2)] px-1.5 py-px font-mono text-[10px] text-[var(--app-text-muted)]';

/** A chip for something switched on / present, in the accent. */
export const detailChipOn = `${detailChip} border-[var(--accent-strong)]/50 text-[var(--app-text)]`;

/** A bordered block — the node detail, a section body that needs a frame. */
export const detailBlock =
  'border border-[var(--border-strong)] bg-[var(--surface-2)] p-2 space-y-1.5';
